import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Highscore from '../components/Highscore'
import * as GameActions from '../actions/game'

function mapStateToProps(state) {
  return {
    board: state.board,
    robot: state.robot,
    status: state.status,
    goals: state.goals,
    log: state.log,
    highscore: state.highscore
  }
}

function mapDispatchToProps(dispatch, ownProps) {
  let actionBindings = bindActionCreators(GameActions, dispatch)
  if(ownProps){
    actionBindings.store = ownProps.store
  }
  return actionBindings
}

export default connect(mapStateToProps, mapDispatchToProps)(Highscore)




// WEBPACK FOOTER //
// ./containers/HighscoreContainer.js